import React, { useEffect } from 'react';
import { format, startOfMonth } from 'date-fns';
import { Controller } from 'react-hook-form';
import { Col, Input, Row } from 'reactstrap';
import Datepicker from 'components/Inputs/DatePicker';
import { useUsers } from 'views/Report/Protocol/hooks/useUsers';
import FlexSelect from 'components/Inputs/FlexSelect';
import { useGetCustomerPortfolios } from 'views/SLA/hooks/useGetCustomerPortfolios';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import { POSSIBLE_FILTERS_ENTITIES } from 'hooks/useMemorizeInputsFilters';
import { useMemorizeFilters } from '../../../../../../../../hooks/useMemorizeInputsFilters';

const dateRules = {
  required: 'Data é obrigatória',
  pattern: {
    value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
    message: 'Data inválida! (dd/MM/aaaa)'
  }
};
const getDateBegin = () => {
  const date = new Date();
  const firstDayMonth = new Date(
    date.getFullYear('pt-br'),
    date.getMonth('pt-br'),
    1
  );
  return format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
};
const toISOFormat = (dateTimeString) => {
  const [date] = dateTimeString.split(' ');
  const [DD, MM, YYYY] = date.split('/');
  return `${DD}/${MM}/${YYYY}`;
};

const DefaultFieldsFilterForm = ({
  control,
  setValue,
  getValues,
  register,
  showDateForm,
  setShowDateForm
}) => {
  const { userList } = useUsers();
  const { customerPortfolios } = useGetCustomerPortfolios();
  const { getMemorizedFilters, changeUniqueMemorizedFilter } =
    useMemorizeFilters(POSSIBLE_FILTERS_ENTITIES.CRM_ACCOUNT);

  useEffect(() => {
    const filters = getMemorizedFilters();
    if (filters) {
      setShowDateForm(filters?.showDateForm || false);
    }
  }, []);

  return (
    <>
      <Row className="mb-3">
        <Col sm="6">
          <label className="form-control-label">Buscar</label>
          <Controller
            as={
              <Input
                type="text"
                name="textQuery"
                placeholder="Buscar por nome ou telefone"
              />
            }
            control={control}
            name="textQuery"
            defaultValue=""
          />
        </Col>
        <Col sm="3">
          <label className="form-control-label">Criado Por</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={userList || []}
                isMulti={true}
                value={props.value || []}
                valueController={setValue}
                fieldName="createdByLogin"
                labelName="name"
                valueName="login"
                isClearable={true}
                closeMenuOnSelect={true}
              />
            )}
            control={control}
            name="createdByLogin"
            defaultValue=""
          />
        </Col>
        <Col sm="3">
          <label className="form-control-label text-capitalize">
            Categoria dos Clientes
          </label>
          <Controller
            control={control}
            name="customerPortfolioId"
            defaultValue=""
            render={(props) => (
              <FlexSelect
                isClearable={true}
                dataOptions={customerPortfolios || []}
                isMulti={true}
                closeMenuOnSelect={true}
                value={props.value || []}
                valueController={setValue}
                fieldName="customerPortfolioId"
                labelName="name"
                valueName="id"
              />
            )}
          />
        </Col>
      </Row>
      <Row className="mb-12">
        <Col className="md-12">
          <label className="form-control-label" style={{ marginLeft: '-15px' }}>
            <ToggleSwitch
              id="showDateForm"
              checked={showDateForm}
              onChange={() => {
                setShowDateForm(!showDateForm);
                changeUniqueMemorizedFilter('showDateForm', !showDateForm);
              }}
              default={false}
            />
            Buscar por data
          </label>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="4">
          <label className="form-control-label">Data inicial</label>
          <Controller
            render={(props) => (
              <Datepicker
                fieldName="dateBegin"
                valueController={setValue}
                defaultValue={props.value}
                shouldDisable={!showDateForm}
              />
            )}
            control={control}
            name="dateBegin"
            rules={dateRules}
            defaultValue={getDateBegin()}
            disabled={!showDateForm}
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Data final</label>
          <Controller
            render={(props) => (
              <Datepicker
                fieldName="dateEnd"
                valueController={setValue}
                defaultValue={props.value}
                shouldDisable={!showDateForm}
              />
            )}
            control={control}
            name="dateEnd"
            defaultValue={new Date().toLocaleDateString('pt-br')}
            disabled={!showDateForm}
            rules={{
              ...dateRules,
              validate: async (value) => {
                if (
                  new Date(toISOFormat(value)) <
                  new Date(toISOFormat(getValues()['dateBegin']))
                ) {
                  return 'A data final não pode ser anterior à inicial!';
                } else {
                  return true;
                }
              }
            }}
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Responsável</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={userList || []}
                isMulti={true}
                value={props.value}
                valueController={setValue}
                fieldName="responsibleLogin"
                labelName="name"
                valueName="login"
                isClearable={true}
                closeMenuOnSelect={false}
              />
            )}
            control={control}
            name="responsibleLogin"
            defaultValue=""
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm="6">
          <label
            className="form-control-label"
            style={{ marginRight: '20px', fontWeight: '400' }}
          >
            <input
              type="radio"
              name="filterDateBy"
              ref={register}
              value="creation"
              defaultChecked={true}
              disabled={!showDateForm}
            />{' '}
            Data de criação
          </label>
          <label className="form-control-label" style={{ fontWeight: '400' }}>
            <input
              type="radio"
              name="filterDateBy"
              ref={register}
              value="last_update"
              defaultChecked={false}
              disabled={!showDateForm}
            />{' '}
            Data de última alteração
          </label>
        </Col>
      </Row>
    </>
  );
};

export default DefaultFieldsFilterForm;
